import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'all',
      component: () => import('./views/login.vue')
    },
   
    {
      path: '/accoutlist',
      name: 'accout',
      component: () => import('./views/home.vue'),
      children: [
        {
          path: '/accoutlist',
          name: 'accoutlist',
          component: () => import('./views/accout/index.vue')
        }
      ]
    },
    
    {
      path: '/companylist',
      name: 'company',
      component: () => import('./views/home.vue'),
      children: [
        {
          path: '/companylist',
          name: 'companylist',
          component: () => import('./views/company/index.vue')
        },
        {
          path: '/splash',
          name: 'splash',
          component: () => import('./views/company/splash.vue')
        },
        {
          path: '/store',
          name: 'store',
          component: () => import('./views/company/store.vue')
        }
      ]
    },
    
    {
      path: '/goodslist',
      name: 'goods',
      component: () => import('./views/home.vue'),
      children: [
        {
          path: '/goodslist',
          name: 'goodslist',
          component: () => import('./views/goods/index.vue')
        },
        {
          path: '/goodsdetail',
          name: 'goodsdetail',
          component: () => import('./views/goods/detail.vue')
        },
        {
          path: '/goodstype',
          name: 'goodstype',
          component: () => import('./views/goods/type.vue')
        }
      ]
    },
    
    {
      path: '/replenishment',
      name: 'replenishment',
      component: () => import('./views/home.vue'),
      children: [
        {
          path: '/replenishmentList',
          name: 'replenishmentList',
          component: () => import('./views/replenishment/index.vue')
        },
        {
          path: '/totallist',
          name: 'totallist',
          component: () => import('./views/replenishment/total.vue')
        },
        {
          path: '/noreplenishmentlist',
          name: 'noreplenishmentlist',
          component: () => import('./views/replenishment/noreplenishmentlist.vue')
        }
      ]
    },
    
    
    {
      path: '/rateList',
      name: 'rate',
      component: () => import('./views/home.vue'),
      children: [
        {
          path: '/rateList',
          name: 'rateList',
          component: () => import('./views/rate/index.vue')
        },
        {
          path: '/profit',
          name: 'profit',
          component: () => import('./views/rate/profit.vue')
        },
        {
          path: '/profitsuccess',
          name: 'profitsuccess',
          component: () => import('./views/rate/profitsuccess.vue')
        },
        {
          path: '/tuikuan',
          name: 'tuikuan',
          component: () => import('./views/rate/tuikuan.vue')
        },
      ]
    },
    {
      path: '/addressList',
      name: 'address',
      component: () => import('./views/home.vue'),
      children: [
        {
          path: '/addressList',
          name: 'addressList',
          component: () => import('./views/address/address.vue')
        }
      ]
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('./views/login.vue')
    },
    {
      path: '/test',
      name: 'test',
      component: () => import('./views/test.vue')
    },
  ]
})
// //避免路由重复
// const VueRouterPush = Router.prototype.push
// Router.prototype.push = function push (to) {
//   return VueRouterPush.call(this, to).catch(err => err)
// }
